module.exports = __webpack_public_path__ + "static/media/background-12.d9989b82.jpg";